import { useReduxBlog } from './useReduxBlog';
import React from 'react';
import { Grid } from '@spotify-internal/frodor-modules';
import styled from 'styled-components';
import {
  Text,
  cssSpacing,
  screenMdMin,
  cssColorValue,
} from '@spotify-internal/encore-web';
import { useT } from '../../../features/src/i18n';
import { TrackVisibility } from '../../utils/Visibility/TrackVisibility';

const BannerGrid = styled.div<{ $backgroundImage?: string }>`
  color: ${cssColorValue('textBase')};
  min-height: 260px;
  @media (min-width: ${screenMdMin}) {
    min-height: 444px;
  }
  padding: 80px ${cssSpacing('looser')} ${cssSpacing('looser')};
  position: relative;
  display: flex;
  align-items: flex-end;
  background-image: ${({ $backgroundImage }) => $backgroundImage || 'none'};
  background-position: center;
  background-size: cover;

  /* Dark overlay for readability */
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: black;
    opacity: 0.3;
    pointer-events: none;
  }
`;

const Title = styled(Text)`
  z-index: 1;
  position: relative;
`;

export const ArtistBanner = () => {
  const { hero } = useReduxBlog();
  const t = useT();

  return (
    <div className="encore-inverted-dark-set">
      <TrackVisibility
        threshold={0.6}
        eventCategory="Frodor - blog page artist banner"
        eventLabel={hero?.artistName || ''}
      >
        <BannerGrid $backgroundImage={hero && `url("${hero.bannerImage}")`}>
          <Title variant="headlineLarge">
            {t('FRODOR_278509', 'News', '')}{' '}
          </Title>
        </BannerGrid>
      </TrackVisibility>
    </div>
  );
};
